<template>
    <div class="plp-container">
        <div class="plp-filter">
          <div class="filter-left" v-if="list.length>0">
            <p @click="clickSeries">{{list[selected].title}}<img src="../assets/image/product/small-arrow-down.png"></p>
            <div :class="['filter-pop',showSeries?'on':'']">
              <p v-bind:key="item.title" v-for='(item,index) in list' :data-in='index' @click="selectSeries(index)" :class="index==selected?'active':''">{{item.title}}</p>
            </div>
          </div>
          <div class="filter-right">
            <div class="row-div">
              <img src="../assets/image/productlist/list.png"/>
              <img src="../assets/image/productlist/row.png"/>
            </div>
            <div class="filter-div" v-if="isNeedFilter" @click="showFilter">
              <p>筛选</p>
              <img src="../assets/image/filter.png">
            </div>
          </div>
        </div>
        <div class="product-list" v-if="list.length>0 && list[selected] && list[selected].items && list[selected].items.length>0" >
          <template v-for='item in list[selected].items'>
            <product-component v-bind:key="item.title"  :goods='item'></product-component>
          </template>
        </div>
      <filter-component v-on:fadeway="fadeFilter" :show='isShowFilter' :level-one-items='filterList' :products='products' ></filter-component>
    </div>
</template>
<style scoped lang="less">
@border: rgb(238, 238, 238);
.plp-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  padding: 0 18px;
  color: #1db6ea;
  font-size: 15px;
  border-bottom: 1px solid @border;
  position: relative;
}
.filter-div {
  border-left: 1px solid @border;
  padding: 0 4px 0 10px;

}
.filter-left img {
  width: 8px;
  margin-left: 6px;
}
.row-div {
  margin-right: 10px;
}
.filter-left > p,
.filter-right,.filter-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 15px;
  }
}
.filter-pop {
  position: absolute;
  left: 0;
  right: 0px;
  top: 35px;
  background-color: rgb(245, 245, 245);
  z-index: 1;
  border-bottom: 1px solid @border;
  transform: translate(0, -1000px);
  transition: all 0.5s ease;
}
.filter-pop.on {
  transform: translate(0, 0px);
}
.filter-pop p {
  border-top: 1px solid @border;
  line-height: 30px;
  margin: 0 18px;
  color: #999999;
}
.filter-pop p.active {
  color: #1db6ea;
}
</style>
<script>
import ProductComponent from "./common/ProductComponent";
import FilterComponent from "./common/FilterComponent";

import LINKTYPE from "../commons/utils/linktype.js";
import pim from "../commons/utils/pim.js";

export default {
  data() {
    return {
      api: this.$store.state.api,
      path: this.$route.query.path,
      showInList: true,
      list: [],
      selected: 0,
      showSeries: false,
      isShowFilter: 0,
      filterList: [],
      isNeedFilter: false,
      products: []
    };
  },

  created() {
    this.getData();
    // await this.getFilterData();
  },
  components: {
    ProductComponent,
    FilterComponent
  },
  methods: {
    async getData() {
      let mypath = this.$route.query.path;
      let result = await pim.seriesList(mypath);
      if (result && result.series) {
        this.list = result.series;
      }
      if (result && result.filters) {
        this.filterList = result.filters;

        if (this.filterList.length > 1) {
          this.isNeedFilter = true;
          //this.isShowFilter = 1;
        }
      } //end of fill filter data

      if (this.$router.currentRoute.query.index) {
        this.selected = this.$router.currentRoute.query.index;
      }

      this.list.forEach(i => {
        console.log(`${i.title} with items size ${i.items.length}`)
        if (i.items) {
          i.items.forEach(pd => {
            if (pd.mapOne) {
              this.products.push(pd);
            }else{
              console.log(`${pd.eightd} has not mapOne`)
            }
          });
        }
      }); //end of product loop

      console.log("check from pim size",this.products.length)
    },
    selectSeries(_index) {
      this.selected = _index;
      this.showSeries = false;
      this.$router.push({
        path: "/ProductList",
        query: { index: this.selected, path: this.path }
      });
      // this.getSku();
    },
    clickSeries() {
      this.showSeries = !this.showSeries;
    },
    showFilter() {
      this.isShowFilter = 1;
    },
    emitShowFilter(val) {
      console.log("val from child", val);
      this.isShowFilter = 0;
    },
    fadeFilter(data) {
      console.log("parent data", data);
      this.isShowFilter = 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue